<div class="dashboard-wrapper">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Painel de Estatísticas</h1>
      <p class="page-header-sub">Visão geral dos indicadores de desempenho e fluxo financeiro da FundCube</p>
    </div>
    <div class="page-header-actions">
      <button type="button" class="btn btn-outline btn-sm" (click)="carregarDadosDashboard()" [disabled]="loading">
        <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
        <span>Atualizar</span>
      </button>
    </div>
  </div>

  <!-- Loading Skeletons -->
  <div *ngIf="loading" class="kpi-grid">
    <div class="kpi-card" *ngFor="let item of [1,2,3,4]">
      <p-skeleton width="42px" height="42px" borderRadius="12px" class="mb-3"></p-skeleton>
      <p-skeleton width="80%" height="2rem" class="mb-2"></p-skeleton>
      <p-skeleton width="50%" height="1rem"></p-skeleton>
    </div>
  </div>

  <!-- Primary KPI Cards (FundCube V.3.0 Standard) -->
  <div *ngIf="!loading" class="kpi-grid">
    <!-- Card 1: Total Arrecadado -->
    <div class="kpi-card kpi-green">
      <div class="kpi-icon"><i class="fas fa-hand-holding-dollar"></i></div>
      <div class="kpi-value">AOA {{ totalApoios | money }}</div>
      <div class="kpi-label">Total Arrecadado</div>
      <span class="kpi-delta up"><i class="fas fa-check-circle"></i> Bruto de doações</span>
    </div>

    <!-- Card 2: Total Campanhas -->
    <div class="kpi-card kpi-blue">
      <div class="kpi-icon"><i class="fas fa-bullhorn"></i></div>
      <div class="kpi-value">{{ totalCampanhas }}</div>
      <div class="kpi-label">Total de Campanhas</div>
      <a routerLink="/admin/campanhas" class="kpi-delta neu" style="text-decoration: none;">
        <i class="fas fa-arrow-right"></i> Ver campanhas
      </a>
    </div>

    <!-- Card 3: Total Utilizadores -->
    <div class="kpi-card kpi-purple">
      <div class="kpi-icon"><i class="fas fa-users"></i></div>
      <div class="kpi-value">{{ totalUtilizadores }}</div>
      <div class="kpi-label">Utilizadores Registados</div>
      <a routerLink="/admin/utilizadores" class="kpi-delta neu" style="text-decoration: none;">
        <i class="fas fa-arrow-right"></i> Ver utilizadores
      </a>
    </div>

    <!-- Card 4: Total Pagamentos -->
    <div class="kpi-card kpi-amber">
      <div class="kpi-icon"><i class="fas fa-hand-holding-heart"></i></div>
      <div class="kpi-value">{{ totalPagamentos }}</div>
      <div class="kpi-label">Total de Apoios / Doações</div>
      <a routerLink="/admin/pagamentos" class="kpi-delta neu" style="text-decoration: none;">
        <i class="fas fa-arrow-right"></i> Ver pagamentos
      </a>
    </div>
  </div>

  <!-- Secondary Metrics: Taxas e Valores Líquidos -->
  <div *ngIf="!loading" class="finance-grid mb-6">
    <div class="finance-card">
      <div class="fc-header">
        <span class="fc-label">Líquido para Campanhas</span>
        <div class="fc-icon green"><i class="fas fa-wallet"></i></div>
      </div>
      <div class="fc-value green">AOA {{ totalLiquidoCampanhas | money }}</div>
      <div class="fc-sub">Valor transferível aos criadores de campanhas</div>
    </div>

    <div class="finance-card">
      <div class="fc-header">
        <span class="fc-label">Taxas de Serviço FundCube</span>
        <div class="fc-icon amber"><i class="fas fa-percentage"></i></div>
      </div>
      <div class="fc-value amber">AOA {{ totalTaxasServico | money }}</div>
      <div class="fc-sub">Comissão retida pela plataforma</div>
    </div>

    <div class="finance-card">
      <div class="fc-header">
        <span class="fc-label">Taxa de Serviço Padrão</span>
        <div class="fc-icon blue"><i class="fas fa-cog"></i></div>
      </div>
      <div class="fc-value blue">{{ taxaServicoConfig }}%</div>
      <div class="fc-sub">Configurada nas definições gerais da plataforma</div>
    </div>
  </div>

  <!-- Detailed Analytics Breakdown Section -->
  <div *ngIf="!loading" class="breakdown-grid mb-6">
    <!-- Campanhas por Estado -->
    <div class="section-card" *ngIf="campanhasPorEstado.length > 0">
      <div class="sc-header">
        <div class="sc-title">
          <i class="fas fa-filter"></i> Campanhas por Estado
        </div>
        <span class="badge badge-green">{{ totalCampanhas }} Total</span>
      </div>
      <div class="sc-body">
        <div class="status-items-grid">
          <div class="status-item-card" *ngFor="let item of campanhasPorEstado">
            <span class="sic-label">{{ item.estadoCampanha }}</span>
            <div class="sic-row">
              <span class="sic-count">{{ item.total }}</span>
              <p-tag [severity]="getSeverity(item.estadoCampanha)" [value]="item.estadoCampanha"></p-tag>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Apoios por Estado & Utilizadores Breakdown -->
    <div class="section-card">
      <div class="sc-header">
        <div class="sc-title">
          <i class="fas fa-chart-pie"></i> Apoios e Composição da Comunidade
        </div>
        <span class="badge badge-blue">{{ totalPagamentos }} Apoios</span>
      </div>
      <div class="sc-body">
        <!-- Apoios por Estado -->
        <div *ngIf="apoiosPorEstado.length > 0" class="mb-4">
          <div class="sub-section-title">Apoios / Doações por Estado</div>
          <div class="apoios-chips-grid">
            <div class="apoio-chip-card" *ngFor="let apoio of apoiosPorEstado">
              <span class="ac-label">{{ apoio.estadoApoio }}</span>
              <span class="ac-value" [ngClass]="{
                'text-green': apoio.estadoApoioENUM === 2,
                'text-amber': apoio.estadoApoioENUM === 1,
                'text-red': apoio.estadoApoioENUM === 3
              }">{{ apoio.total }}</span>
            </div>
          </div>
        </div>

        <!-- Demografia de Utilizadores -->
        <div *ngIf="utilizadoresStats">
          <div class="sub-section-title">Composição de Utilizadores ({{ utilizadoresStats.totalUtilizadores }} total)
          </div>
          <div class="demografia-grid">
            <div class="demo-box green">
              <span class="demo-label">Activos</span>
              <span class="demo-value">{{ utilizadoresStats.ativos }}</span>
            </div>
            <div class="demo-box red">
              <span class="demo-label">Inactivos</span>
              <span class="demo-value">{{ utilizadoresStats.inativos }}</span>
            </div>
            <div class="demo-box blue">
              <span class="demo-label">Nacionais</span>
              <span class="demo-value">{{ utilizadoresStats.nacional }}</span>
            </div>
            <div class="demo-box purple">
              <span class="demo-label">Estrangeiros</span>
              <span class="demo-value">{{ utilizadoresStats.estrangeiro }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Recent Transactions Table -->
  <div class="section-card mb-6">
    <div class="sc-header">
      <div>
        <div class="sc-title">
          <i class="fas fa-receipt"></i> Últimos Pagamentos e Apoios
        </div>
        <div class="sc-subtitle">Transações recentes registradas no sistema</div>
      </div>
      <div class="sc-actions">
        <a routerLink="/admin/pagamentos" class="btn btn-ghost btn-sm">
          <span>Ver todos</span> <i class="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>

    <div *ngIf="recentPagamentos && recentPagamentos.length > 0; else noPayments" class="inv-table-wrap">
      <table class="inv-table">
        <thead>
          <tr>
            <th>Doador</th>
            <th>Campanha</th>
            <th>Data</th>
            <th>Valor Total</th>
            <th>Taxa ({{ taxaServicoConfig }}%)</th>
            <th>Valor Campanha</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pagamento of recentPagamentos">
            <td data-label="Doador">
              <div class="user-cell">
                <div class="user-avatar-sm"><i class="fas fa-user"></i></div>
                <span class="user-name">{{ pagamento?.utilizadorNome || 'Anônimo' }}</span>
              </div>
            </td>
            <td data-label="Campanha">
              <span class="camp-title-cell">{{ pagamento?.campanha?.titulo || 'Campanha' }}</span>
            </td>
            <td data-label="Data">
              <span class="date-cell">{{ pagamento?.dataCriacaoFormatada || '-' }}</span>
            </td>
            <td data-label="Valor Total">
              <strong class="val-cell">AOA {{ (pagamento?.valorDoadoTotal ?? pagamento?.valorApoio) | money }}</strong>
            </td>
            <td data-label="Taxa">
              <span class="taxa-cell text-amber">
                + AOA {{ (pagamento?.valorTaxa ?? ((pagamento?.valorApoio * (pagamento?.taxaServico ||
                taxaServicoConfig)) / 100)) | money }}
              </span>
            </td>
            <td data-label="Valor Campanha">
              <span class="net-cell text-green">
                AOA {{ (pagamento?.valorDoadoCampanha ?? pagamento?.valorApoio) | money }}
              </span>
            </td>
            <td data-label="Estado">
              <p-tag [severity]="getSeverity(pagamento?.estadoApoio)"
                [value]="pagamento?.estadoApoio || 'Confirmado'"></p-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #noPayments>
      <div class="empty-state">
        <div class="empty-icon"><i class="fas fa-inbox"></i></div>
        <div class="empty-title">Nenhum pagamento registrado</div>
        <p class="empty-desc">Ainda não existem transações recentes na plataforma.</p>
      </div>
    </ng-template>
  </div>

  <!-- Recent Campaigns and Activity Grid -->
  <div class="dual-grid">
    <!-- Campanhas Recentes -->
    <div class="section-card">
      <div class="sc-header">
        <div class="sc-title">
          <i class="fas fa-bullhorn"></i> Campanhas Recentes
        </div>
        <a routerLink="/admin/campanhas" class="btn btn-ghost btn-sm">Ver todas</a>
      </div>
      <div class="sc-body">
        <div class="recent-list" *ngIf="recentCampanhas.length > 0; else noRecentCamp">
          <div *ngFor="let camp of recentCampanhas" class="recent-item">
            <div class="ri-info">
              <span class="ri-title">{{ camp?.titulo }}</span>
              <span class="ri-meta">{{ camp?.categoria?.descricao || 'Geral' }} &bull; Meta: AOA {{
                camp?.metaArrecadacao | money }}</span>
            </div>
            <p-tag [severity]="getSeverity(camp?.estadoCampanha)" [value]="camp?.estadoCampanha || 'Ativa'"></p-tag>
          </div>
        </div>
        <ng-template #noRecentCamp>
          <p class="empty-text">Nenhuma campanha recente.</p>
        </ng-template>
      </div>
    </div>

    <!-- Registos de Atividade Recentes -->
    <div class="section-card">
      <div class="sc-header">
        <div class="sc-title">
          <i class="fas fa-history"></i> Registos de Atividade
        </div>
        <a routerLink="/admin/registos" class="btn btn-ghost btn-sm">Ver todos</a>
      </div>
      <div class="sc-body">
        <div class="recent-list" *ngIf="recentLogs.length > 0; else noRecentLogs">
          <div *ngFor="let log of recentLogs" class="recent-item">
            <div class="ri-icon-wrap">
              <i class="fas fa-clock-rotate-left"></i>
            </div>
            <div class="ri-info">
              <span class="ri-title">{{ log?.descricao || log?.acao || 'Ação do Sistema' }}</span>
              <span class="ri-meta">{{ log?.dataCriacaoFormatada || log?.data || 'Recente' }}</span>
            </div>
          </div>
        </div>
        <ng-template #noRecentLogs>
          <p class="empty-text">Nenhum registo recente.</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>